<template>
  <div id="commonPage_programList" v-show="currThemeObj">
    <div
      class="abs_topArea"
      :style="{
        backgroundImage: `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/${themeHeaderBannerImage}.png')`,
      }"
    >
      <div class="dateArea">
        <div class="datePicker">
          <el-date-picker
            v-model="currDate"
            popper-class="datePicker_datePackagList"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @change="changeDate"
          ></el-date-picker>
        </div>
        <div class="seasonStartEndDate">
          <span class="title" v-text="seasonTitle"></span>
          <span class="title" v-text="startEndDateArr.join(' 至 ')"></span>
        </div>
      </div>
    </div>
    <div class="programList_main">
      <div class="themeOperation_area">
        <span
          class="themeType_changeArea"
          v-if="channelArr && channelArr.length > 0"
        >
          <span
            class="themeType_item"
            v-for="item in channelArr"
            :key="item.value"
            :class="item.act ? 'act' : ''"
            v-text="item.label"
            @click="changeTabs(item)"
          ></span>
        </span>

        <span class="themeBtn_area" v-if="channelArr && channelArr.length > 0">
          <span
            v-for="item in pageBtnList"
            :key="item.key"
            v-text="item.name"
            @click="openDialog(item.key)"
          ></span>
        </span>
        <template v-if="themeItem && programList && programList.length > 0">
          <multipleChoiceShare_fixedBtn
            :model="multipleChoiceShareFixedBtn_model"
            :state="multipleChoiceShareFixedBtn_state"
            :modeType="multipleChoiceShareFixedBtn_modeType"
            :smallBtnArr="smallBtnArr"
            :fixedBtn_absTopArr="['9.735vw', '22.3vw']"
            :rectBtnShowBorder="true"
            @changeModelEvent="changeModelEventHandler"
            @clickSmallBtnEvent="clickSmallBtnEventHandler"
            @clickFixedBtnEvent="clickFixedBtnEventHandler"
            :isShow="!noData"
          ></multipleChoiceShare_fixedBtn>
        </template>
      </div>
      <div class="programList">
        <CompProgramList
          v-if="programList && programList.length > 0"
          :currCid="currCid"
          :currSid="currSid"
          :currThemeObj="currThemeObj"
          :data="programList"
          :detailPathName="''"
          :chooseState="multipleChoiceShareFixedBtn_state"
          :localStorageName="
            multipleChoiceShareFixedBtn_modeType &&
            multipleChoiceShareFixedBtn_modeType.localStorageName
              ? multipleChoiceShareFixedBtn_modeType.localStorageName
              : ''
          "
          :localStorageSaveDate="''"
          @changeChooseNumEvent="changeChooseNumEventHandler"
          :viewMode="''"
          @clickRightBtnEvent="clickRightBtnEventHandler"
        ></CompProgramList>
      </div>
    </div>
    <NOT_DATA
      :className="'relativePtb60'"
      v-show="programList && programList.length == 0"
    />

    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
    <el-dialog
      :title="
        [
          'programItem_eidtItem',
          'programItem_removeItem',
          'removeDateProgramItem',
        ].includes(dialogType)
          ? dialogText
          : ''
      "
      custom-class="mixtmt_dialog"
      :visible.sync="isDialogFlag"
      width="42vw"
      top="0"
      center
    >
      <template v-if="['programItem_eidtItem'].includes(dialogType)">
        <SingleProgramItemSlotPop
          :options="singleProgramItemSlotPop_options_eidt"
        ></SingleProgramItemSlotPop>
      </template>
      <span slot="footer" class="dialog-footer">
        <span @click="cancelDialog">取 消</span>
        <span @click="clickThemeBtnArea(dialogType)" class="ok">确 定</span>
      </span>
    </el-dialog>

    <complex_multipleChoiceShare_dialog
      v-if="dialogItem && dialogItem.isDialogFlag"
      :currThemeObj="currThemeObj"
      :axiosBaseUrl="axiosBaseUrl"
      :platfromMenu_currGroup="currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :dialogItem="dialogItem"
      :themeItem="themeItem"
      :localStorageChooseList="localStorageChooseList"
      :multipleChoiceShareFixedBtn_modeType="
        multipleChoiceShareFixedBtn_modeType
      "
      :curTimeZoneItem="curTimeZoneItem"
      @dialogCancelEvent="clickSmallBtnEventHandler"
      @dialogOkEvent="dialogOkEventHandler"
      @shareDoneEvent="shareDoneEventHandler"
    >
      <template v-slot:checkList>
        <CompProgramList
          :currCid="currCid"
          :currSid="currSid"
          :currThemeObj="currThemeObj"
          :data="localStorageChooseList"
          :detailPathName="''"
          :chooseState="multipleChoiceShareFixedBtn_state"
          :localStorageName="
            multipleChoiceShareFixedBtn_modeType &&
            multipleChoiceShareFixedBtn_modeType.localStorageName
              ? multipleChoiceShareFixedBtn_modeType.localStorageName
              : ''
          "
          :localStorageSaveDate="''"
          @changeChooseNumEvent="changeChooseNumEventHandler"
          :viewMode="'shareAfterView'"
        ></CompProgramList>
      </template>
    </complex_multipleChoiceShare_dialog>

    <!-- 创建节目单 弹窗 -->
    <MenuListDialog
      :currThemeObj="currThemeObj"
      :isShowFlag="menuListDialog_isShowFlag"
      :dialogObj="menuListDialog_dialogObj"
      :menuList="menuListDialog_menuList"
      :dialogTipObj="menuListDialog_dialogTipObj"
      @closePopEvent="closePopEventHandler"
      @clickMenuItemEvent="clickMenuItemEventHanlder"
    >
      <template v-slot:headerBtn>
        <span class="dialog_btn">
          <!-- <span @click="menuListDialog_clickBtn('-1')">取 消</span> -->
          <span
            @click="menuListDialog_clickBtn('2')"
            class="keepOn"
            v-text="'保存并继续添加'"
          ></span>
          <span
            @click="menuListDialog_clickBtn('1')"
            class="ok"
            v-text="'保存'"
          ></span>
        </span>
      </template>
      <template v-slot:bodyRight>
        <span class="cardItemGroup_header">
          <span class="headerInfor">
            <span
              class="headerInfor_title"
              v-text="
                menuListDialog_actMenuItem && menuListDialog_actMenuItem.name
                  ? menuListDialog_actMenuItem.name
                  : ''
              "
            ></span>
            <!-- <span class="headerInfor_tipIcon">
              <el-tooltip
                effect="dark"
                content="设计风格最少选择一种"
                placement="top"
                popper-class="publicThemeDialog_toolTip"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </span> -->
          </span>
        </span>
        <template
          v-if="
            menuListDialog_actMenuItem &&
            menuListDialog_actMenuItem.type === 'singleAddItem'
          "
        >
          <SingleProgramItemSlotPop
            :options="singleProgramItemSlotPop_options_add"
          ></SingleProgramItemSlotPop>
        </template>
        <template v-else>
          <div class="group_popup_row">
            <span class="" v-text="'下载模版：'"></span>
            <span class="row_right_item">
              <span class="rowRightItem_icon" @click="downExcelDemo">
                <svg
                  t="1713166633419"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2425"
                  width="100%"
                  height="100%"
                >
                  <path
                    d="M204.8 0h477.866667l273.066666 273.066667v614.4c0 75.093333-61.44 136.533333-136.533333 136.533333H204.8c-75.093333 0-136.533333-61.44-136.533333-136.533333V136.533333C68.266667 61.44 129.706667 0 204.8 0z m354.986667 641.706667L682.666667 518.826667c13.653333-13.653333 13.653333-34.133333 0-47.786667-20.48-6.826667-40.96-6.826667-54.613334 6.826667L505.173333 593.92 389.12 477.866667c-13.653333-13.653333-34.133333-13.653333-47.786667 0-13.653333 13.653333-13.653333 34.133333 0 47.786666l122.88 122.88L341.333333 764.586667c-13.653333 13.653333-13.653333 34.133333 0 47.786666 13.653333 13.653333 34.133333 13.653333 47.786667 0l122.88-122.88 122.88 122.88c13.653333 13.653333 34.133333 13.653333 47.786667 0 13.653333-13.653333 13.653333-34.133333 0-47.786666L559.786667 641.706667z"
                    p-id="2426"
                  ></path>
                  <path
                    d="M682.666667 0l273.066666 273.066667h-204.8c-40.96 0-68.266667-27.306667-68.266666-68.266667V0z"
                    fill="#E0E0E0"
                    opacity=".619"
                    p-id="2427"
                  ></path>
                </svg>
              </span>
            </span>
          </div>
          <div
            class="group_popup_row"
            :class="batchUploadObj.className ? batchUploadObj.className : ''"
          >
            <span
              v-if="batchUploadObj.isRequest"
              v-text="`*${batchUploadObj.name}`"
            ></span>
            <span v-else v-text="`${batchUploadObj.name}`"></span>
            <div class="row_right_item">
              <uploadFileList
                :item="{
                  value: batchUploadObj.value,
                  key: batchUploadObj.key,
                }"
                :axiosBaseUrl="axiosBaseUrl_custom"
                :limitNum="1"
                :uploadType="batchUploadObj.type"
                :uploadTextTip="batchUploadObj.textTip"
                tooltipPopperClass="programList"
                :customUploadCallback="uploadFileList_customUploadCallback"
                @submitImageEvent="submitImageEventHandler"
              />
            </div>
          </div>
        </template>
      </template>
    </MenuListDialog>
  </div>
</template>

<script>
import {
  https_programList_postProgramList,
  https_programList_postChannelList,
  https_programList_postAddSingleProgram,
  https_programList_postUpdateProgram,
  https_programList_postDeleteProgram,
  https_programList_postImportExcel,
  https_programList_postDeleteDateAllProgram,
} from '@api/platfrom_base_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
import multipleChoiceShare_data_mixin from '@mixins/multipleChoiceShare_data'
import multipleChoiceShare_fixedBtn from '@components/platfromBase/compreSportsMeet/multipleChoiceShare_fixedBtn.vue'
import complex_multipleChoiceShare_dialog from '@components/platfromBase/compreSportsMeet/complex_multipleChoiceShare_dialog.vue'
import CompProgramList from '@components/commonPage/programList/comp_programList.vue'
import BackTop from '@components/base/backTop.vue'
import NOT_DATA from '@components/base/NO_DATA.vue'
import MenuListDialog from '@components/base/menuList_dialog.vue'
import SingleProgramItemSlotPop from '@components/commonPage/programList/singleProgramItem_slotPop.vue'
import uploadFileList from '@/components/base/uploadFileList.vue'

import axios from 'axios'

const envPro = require('@src/envPro/index')
const curApiObj = envPro.computedEnvApi()
const { VUE_APP_APIURL_PROG } = curApiObj
// import axios from 'axios'
// const { CancelToken, isCanCel } = axios
export default {
  name: 'commonPage_programList',
  mixins: [cup_base_data_mixin, multipleChoiceShare_data_mixin],
  components: {
    NOT_DATA,
    BackTop,
    CompProgramList,
    multipleChoiceShare_fixedBtn,
    complex_multipleChoiceShare_dialog,
    MenuListDialog,
    SingleProgramItemSlotPop,
    uploadFileList,
  },
  props: {
    themeHeaderBannerImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      themeTemplateType: 36,
      crossSeason: true, //是否跨赛事
      axiosBaseUrl_custom: '/prog',
      seasonTitle: '',
      currDate: '',
      startEndDateArr: [],
      channelArr: [],
      currChannelObj: null,
      pageBtnList: [
        {
          name: '+节目单',
          key: 'addSingleProgramItem',
        },
        {
          name: '删除当天',
          key: 'removeDateProgramItem',
        },
      ],

      programListParams: null, //某个演播室接口参数对象
      userRoleKey_pushMaterial: 'pushMaterial',
      isShowPushMaterialBtn: false, //true为展示【推送】按钮

      scrollDomById: 'containerFull_body',
      showBackTop: false,

      programList: null,
      multipleChoiceShareFixedBtn_modeType: {
        btnName: '创建预告',
        type: 'programListPreviewThomasAndUber',
        localStorageName: 'mixtmt_choose_programListPreviewThomasAndUber',
        unit: '条',
      },

      isDialogFlag: false,
      menuListDialog_isShowFlag: false,
      menuListDialog_dialogObj: {
        cardWH: ['50vw', '25vw'],
        dialogText: '创建节目单',
      },
      menuListDialog_menuList: [
        {
          type: 'batchUpload',
          name: '批量上传',
          act: false,
        },
        {
          type: 'singleAddItem',
          name: '单个添加',
          act: false,
        },
      ],
      menuListDialog_actMenuItem: null,
      menuListDialog_dialogTipObj: null,
      dialogText: '',
      dialogType: 'programItem_eidtItem', //'programItem_eidtItem','programItem_removeItem','removeDateProgramItem'
      singleProgramItemSlotPop_options_orgin: [
        {
          title: '日期：',
          key: 'el-icon-date',
          value: '',
          type: 'DatePicker',
          tipText: '请选择日期',
        },
        {
          title: '时间：',
          key: 'el-icon-time',
          value: '',
          type: 'TimePicker',
          tipText: '请选择时间',
        },
        {
          title: '频道：',
          key: 'el-icon-monitor',
          value: '',
          type: 'select',
          list: [],
          tipText: '请选择频道',
        },
        {
          title: '节目：',
          key: 'el-icon-edit',
          value: '',
          type: 'input',
          tipText: '请输入节目名称',
        },
      ],
      singleProgramItemSlotPop_options_eidt: [],
      singleProgramItemSlotPop_options_add: [],
      batchUploadObj: {
        name: '批量上传：',
        key: 'previewMedia',
        isRequest: false,
        type: 'uploadFile',
        ceil: '',
        className: 'alignItemsStart',
        textTip: '', // 上传视频提示
        value: '',
      },
    }
  },
  created() {
    // this.axiosCancelSource = CancelToken.source()
    this.getUserRoleList()
    if (this.mixtmt_userRoleKeyList.includes(this.userRoleKey_pushMaterial)) {
      // 是否展示【推送】按鈕
      this.isShowPushMaterialBtn = true
    }
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noData() {
      return this.programList && this.programList.length === 0
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug('currGroup dataPackagList:', this.currGroup)
      const query = this.$route.query
      const todayObj = new Date()
      const year = todayObj.getFullYear()
      const month =
        Number(todayObj.getMonth() + 1) > 9
          ? Number(todayObj.getMonth() + 1)
          : `0${Number(todayObj.getMonth() + 1)}`
      const date =
        todayObj.getDate() > 9 ? todayObj.getDate() : `0${todayObj.getDate()}`
      this.currDate = `${year}-${month}-${date}`
      await this.getChannelList()
      if (this.initFindanalysisItem && (!this.themeItem || !this.crossSeason)) {
        this.initFindanalysisItem()
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    openDialog(type) {
      if (type === 'addSingleProgramItem') {
        // 添加单个节目单，组装数据
        this.singleProgramItemSlotPop_options_add = JSON.parse(
          JSON.stringify(this.singleProgramItemSlotPop_options_orgin)
        )
        this.clickMenuItemEventHanlder(this.menuListDialog_menuList[0])
        this.menuListDialog_isShowFlag = true
      } else if (type === 'removeDateProgramItem') {
        this.dialogType = type
        this.dialogText = `请确认是否删除当天所有节目`
        this.isDialogFlag = true
      }
    },
    clickRightBtnEventHandler(data) {
      this.currProgramItem = data.item
      if (data.type === 'edit') {
        this.dialogType = 'programItem_eidtItem'
        this.dialogText = `修改【${data.item.time}】节目`
        let options_eidt = JSON.parse(
          JSON.stringify(this.singleProgramItemSlotPop_options_orgin)
        )
        options_eidt[1].value = data.item.time
        options_eidt[2].value = data.item.channelId
        options_eidt[3].value = data.item.description
        this.singleProgramItemSlotPop_options_eidt = options_eidt
        this.isDialogFlag = true
      } else if (data.type === 'remove') {
        this.dialogType = 'programItem_removeItem'
        this.dialogText = `请确认是否删除【${data.item.time}】的节目`
        this.isDialogFlag = true
      }
    },
    changeChooseNumEventHandler(data) {
      // 这个是多选分享每个.vue文件根据数据结构，单独写的
      if (data.init) {
        // 清除缓存，重新开始
        this.$localStorage.removeItem(
          data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        // multipleChoiceShare_fixedBtn 组件清除缓存数据时，源数据是否要重置
        this.programList.forEach((match) => {
          match.isChooseFlag = false
        })
      } else {
        const chooseSchedule = JSON.parse(
          this.$localStorage.getItem(
            data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
          )
        )
        console.debug('data.type:', data, chooseSchedule)
        let programList = JSON.parse(JSON.stringify(this.programList))
        programList.forEach((item) => {
          if (chooseSchedule.chooseIdArr.includes(item.chooseId)) {
            item.isChooseFlag = true
          } else {
            item.isChooseFlag = false
          }
        })
        this.programList = programList
        this.$localStorage.setItem(
          data.localStorageName,
          JSON.stringify(chooseSchedule)
        )
        this.localStorageChooseList = chooseSchedule.chooseItemArr
      }
      this.smallBtnArr.forEach((item) => {
        if (item.type === 'check') {
          item.val = data.val
        }
      })
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }

      this.beforeScrollTop = 0
      // this.threshold = 5
      // this.DIRECTION_ENUM = {
      //   DOWN: 'down',
      //   UP: 'up',
      // }

      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    scrollListenerEvent() {
      console.debug('scrollListenerEvent')
      const scrollTop = this.scrollAreaDom.scrollTop

      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      // multipleChoiceShare_fixedBtn 需要
      this.scrollChangeHandler(scrollTop)

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    changeTabs(item) {
      this.channelArr.forEach((user) => {
        if (user.value === item.value) {
          user.act = true
          this.currChannelObj = user
        } else {
          user.act = false
        }
      })
      this.loadMediaThemeList()
      console.debug('changeTabs:', item, this.currChannelObj)
    },
    cancelDialog() {
      // 修改 | 删除 弹窗【取消】
      this.dialogType = ''
      this.dialogText = ''
      this.isDialogFlag = false
    },
    clickThemeBtnArea(type) {
      if (type === 'programItem_eidtItem') {
        // 修改弹窗【确认】，提交完之后刷新列表
        let { valArr, isPass } = this.formatProgramItem(
          this.singleProgramItemSlotPop_options_eidt
        )
        if (isPass) {
          valArr[4] = this.currProgramItem.programId
          this.postUpdateProgram(valArr)
          this.cancelDialog()
        } else {
          this.$message({
            showClose: true,
            message: this.menuListDialog_dialogTipObj.tipText,
            type: 'warning',
          })
        }
      } else if (type === 'programItem_removeItem') {
        // 删除弹窗【确认】，提交完之后刷新列表
        this.postDeleteProgram(this.currProgramItem)
      } else if (type === 'removeDateProgramItem') {
        this.postDeleteDateAllProgram(this.currDate)
      }
    },
    menuListDialog_clickBtn(state) {
      // '-1': 取消； '1': 保存; '2': 保存并继续创建
      if (state === '-1') {
        this.menuListDialog_isShowFlag = false
      } else {
        const { valArr, isPass } = this.formatProgramItem(
          this.singleProgramItemSlotPop_options_add
        )
        if (isPass) {
          this.postAddSingleProgram(valArr, state)
          if (state === '1') {
            // 保存需要关闭，【保存并继续添加】不用关闭，重置对象即可
            this.menuListDialog_clickBtn('-1')
          }
        } else {
          window.setTimeout(() => {
            this.menuListDialog_dialogTipObj = null
          }, 3 * 1000)
        }
      }
    },
    formatProgramItem(opts) {
      const valArr = []
      let isPass = true
      for (let i = 0; i < opts.length; i++) {
        const item = opts[i]
        if (item.value) {
          valArr.push(item.value)
        } else {
          this.menuListDialog_dialogTipObj = {
            type: 'error',
            tipText: item.tipText,
          }
          isPass = false
          break
        }
      }
      return {
        isPass,
        valArr,
      }
    },
    submitImageEventHandler(data) {
      console.debug('图片生产的oss在线连接:', data)
      if (this.popupShow) {
        if (data.uploadFileItem.key === 'coverPhoto') {
          this.addCamerObj.coverPhoto = data.fullOssUrl
          this.addCamerObj.coverPhoto_absOssUrl = data.absOssUrl
        } else if (data.uploadFileItem.key === 'previewMedia') {
          this.addCamerObj.previewMedia = data.fullOssUrl
          this.addCamerObj.previewMedia_absOssUrl = data.absOssUrl
        }
      } else if (data.uploadFileItem.key) {
        this.videoParamsArr.forEach((item) => {
          if (data.uploadFileItem.key === item.paramKey) {
            item.paramValue_absOssUrl = data.absOssUrl
            item.paramValue = data.fullOssUrl
          }
        })
        console.debug(this.videoParamsArr, this.addCamerObj)
      }
    },
    closePopEventHandler() {
      console.debug('closePopEventHandler')
      this.menuListDialog_clickBtn('-1')
    },
    clickMenuItemEventHanlder(data) {
      this.menuListDialog_menuList.forEach((menuItem) => {
        if (menuItem.type === data.type) {
          menuItem.act = true
          this.menuListDialog_actMenuItem = menuItem
        } else {
          menuItem.act = false
        }
      })
    },
    changeDate() {
      // this.loadMediaThemeList()
      this.getChannelList()
    },
    async loadMediaThemeList() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      // 组装节目单参数
      this.programListParams = {
        channelId: this.currChannelObj.value,
        date: this.currDate,
      }
      await this.getProgramList(this.programListParams)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async getChannelList() {
      https_programList_postChannelList(this.axiosBaseUrl_custom, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.channelArr = res.data
              ? res.data.map((item, itemIndex) => {
                  return {
                    label: item.channelName,
                    value: item.channelId,
                    logo: item.channelPicture,
                    act: false,
                  }
                })
              : []
            let options_orgin = JSON.parse(
              JSON.stringify(this.singleProgramItemSlotPop_options_orgin)
            )
            options_orgin[0].value = this.currDate // 设置今天日期
            options_orgin[2].value = this.channelArr[0].value
            options_orgin[2].list = this.channelArr
            this.singleProgramItemSlotPop_options_orgin = options_orgin
            this.changeTabs(this.channelArr[0])
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getProgramList(query) {
      //获取某日节目单列表
      await https_programList_postProgramList(
        this.axiosBaseUrl_custom,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.programList = res.data.map((item) => {
              let newItem = item
              newItem.date = this.currDate
              newItem.channelName =
                this.currChannelObj && this.currChannelObj.label
                  ? this.currChannelObj.label
                  : ''
              newItem.chooseId = item.programId
              newItem.isChooseFlag = false
              return newItem
            })
            this.initScroll()
            if (this.scrollAreaDom.scrollTop > 200) {
              // 自动刷新不需要返回顶部
              this.goBackTop() //返回顶部
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
          // const res = {
          //   status: 0,
          //   message: 'success',
          //   data: [
          //     {
          //       channelId: 1,
          //       programId: 'ea586f4ff8504ae88080506d3c2d3df5',
          //       time: '12:39',
          //       description: 'test2',
          //     },
          //     {
          //       channelId: 1,
          //       programId: '4407ea24ca64495c935c8ae2fbedf977',
          //       time: '12:35',
          //       description: 'test1',
          //     },
          //   ],
          // }
        })
    },
    async postAddSingleProgram(valArr, state) {
      // 添加单个节目
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      let params = {
        date: valArr[0],
        time: valArr[1],
        channelId: valArr[2],
        description: valArr[3],
      }
      await https_programList_postAddSingleProgram(
        this.axiosBaseUrl_custom,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            window.mixtmtBase_eventBus.$emit('loadingEvent', false)
            this.singleProgramItemSlotPop_options_add = null
            this.$message({
              showClose: true,
              message: '创建成功',
              type: 'success',
            })
            this.loadMediaThemeList()
            if (state === '2') {
              // 保存并继续添加
              this.singleProgramItemSlotPop_options_add = JSON.parse(
                JSON.stringify(this.singleProgramItemSlotPop_options_orgin)
              )
              // this.openDialog('addSingleProgramItem')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async postUpdateProgram(valArr) {
      // 修改单个节目
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      let params = {
        date: valArr[0],
        time: valArr[1],
        channelId: valArr[2],
        description: valArr[3],
        programId: valArr[4],
      }
      await https_programList_postUpdateProgram(
        this.axiosBaseUrl_custom,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            window.mixtmtBase_eventBus.$emit('loadingEvent', false)
            this.singleProgramItemSlotPop_options_eidt = null
            this.currProgramItem = null
            this.cancelDialog()
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success',
            })
            this.loadMediaThemeList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async postDeleteProgram(item) {
      // 删除单个节目
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      let params = {
        programId: item.programId,
      }
      await https_programList_postDeleteProgram(
        this.axiosBaseUrl_custom,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            window.mixtmtBase_eventBus.$emit('loadingEvent', false)
            this.currProgramItem = null
            this.cancelDialog()
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
            this.loadMediaThemeList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async postDeleteDateAllProgram(currDate) {
      // 删除当天所有节目
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      let params = {
        date: currDate,
      }
      await https_programList_postDeleteDateAllProgram(
        this.axiosBaseUrl_custom,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            window.mixtmtBase_eventBus.$emit('loadingEvent', false)
            this.currProgramItem = null
            this.cancelDialog()
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
            this.loadMediaThemeList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    downExcelDemo() {
      let origin = window.location && window.location.origin
      if (origin) {
        const href = `${origin}/prog/work/exampleExcel`
        window.open(href, '_blank')
      } else {
        console.debug('window.location.origin 没有找到')
      }
    },
    uploadFileList_customUploadCallback(file) {
      const formData = new FormData()
      formData.append('file', file.raw)
      // console.debug('formData', formData)
      this.postImportExcel(formData)
    },
    async postImportExcel(params) {
      // 批量上传节目单
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)

      await https_programList_postImportExcel(
        this.axiosBaseUrl_custom,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            window.mixtmtBase_eventBus.$emit('loadingEvent', false)
            this.$message({
              showClose: true,
              message: '上传成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#commonPage_programList {
  padding-top: 6.94vw;
  .abs_topArea {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 6.94vw;
    color: var(--mixtmt_whiteColor);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
    .dateArea {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      height: 6.94vw;
    }
    .datePicker {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      height: 6.94vw;
      width: 13.88vw;
    }
    .seasonStartEndDate {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      height: 6.94vw;
      width: calc(100% - 16.66vw);
      span {
        letter-spacing: 0.1vw;
        font-size: 1.38vw;
        color: var(--mixtmt_whiteColor);
      }
    }
  }
  .programList_main {
    width: 100%;
    padding: 2.083vw 0 2.778vw;
    .themeOperation_area {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 2.5vw;
      .themeType_changeArea {
        width: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        border: 1px solid var(--mixtmt_btn_tabMeun_actColor);
        border-radius: 1.25vw;
        .themeType_item {
          padding: 0 1.38vw;
          width: auto;
          line-height: calc(2.5vw - 2px);
          text-align: center;
          color: var(--mixtmt_btn_tabMeun_actColor);
          font-size: 0.972vw;
          border-left: 1px solid;
          border-right: 1px solid;
          &.act {
            background-color: var(--mixtmt_btn_tabMeun_actColor);
            color: var(--mixtmt_whiteColor);
            &:first-child {
              border-radius: 1.25vw 0 0 1.25vw;
            }
            &:last-child {
              border-radius: 0 1.25vw 1.25vw 0;
            }
          }
          &:first-child,
          &:last-child {
            border: 0;
          }
        }
      }
      .themeBtn_area {
        flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        span {
          display: inline-block;
          margin-left: 0.972vw;
          line-height: calc(2.5vw - 2px);
          font-size: 1.11vw;
          padding: 0 0.972vw;
          border: 1px solid var(--mixtmt_greyColor7);
          color: var(--mixtmt_greyColor2);
          border-radius: 2px;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
    .programList {
      padding-top: 2.083vw;
    }
  }

  .dialog_btn {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: center;
    width: auto;
    flex-direction: row-reverse;
    span {
      padding: 0 1.388vw;
      width: auto;
      height: 2.5vw;
      background-color: var(--mixtmt_whiteColor);
      line-height: calc(2.5vw - 2px);
      color: var(--mixtmt_greyColor2);
      border: 1px solid var(--mixtmt_greyColor6);
      border-radius: 0.347vw;
      &.ok {
        background-color: var(--mixtmt_subColor1_1);
        border: 1px solid var(--mixtmt_subColor1_1);
        color: var(--mixtmt_whiteColor);
      }
      &.keepOn {
        background-color: var(--mixtmt_mainColor);
        border: 1px solid var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);
      }
      &:nth-child(2) {
        margin-right: 1.388vw;
      }
    }
  }

  .cardItemGroup_header {
    position: relative;
    margin-bottom: 1.388vw;
    width: 100%;
    height: 2.2vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    &::before {
      content: '\20';
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 2;
      width: 3.25vw;
      height: 0.22vw;
      background-color: var(--mixtmt_mainColor);
      border-radius: 0.125vw;
    }
    .headerInfor {
      width: 100%;
      height: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .headerInfor_title {
        font-size: 1.1vw;
        color: var(--mixtmt_greyColor3);
        font-weight: bold;
        padding-right: 0.347vw;
      }
      .headerInfor_tipIcon {
        position: relative;
        width: 1.388vw;
        height: 1.388vw;
        & > i {
          font-size: 1.388vw;
          color: var(--mixtmt_greyColor0);
        }
      }
    }
  }

  .group_popup_row {
    margin-bottom: 1.388vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    &.alignItemsStart {
      align-items: flex-start;
      & > span {
        padding-top: 0.208vw;
      }
    }
    .row_right_item {
      flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      &.flexColumn {
        flex-direction: column;
        align-items: flex-start;
      }
      .ceil {
        padding-left: 0.694vw;
        font-size: 0.972vw;
        font-weight: 600;
        color: var(--mixtmt_greyColor2);
      }
      .rowRightItem_icon {
        width: 2.083vw;
        height: 2.083vw;
        svg {
          fill: var(--mixtmt_mainColor6);
        }
      }
    }
    & > span {
      width: 8.333vw;
      padding-right: 0.694vw;
      text-align: right;
      font-size: 0.972vw;
      font-weight: 600;
      color: var(--mixtmt_greyColor2);
    }
  }
}
.mixtmt_pc #commonPage_programList,
.mixtmt_ipad #commonPage_programList {
  padding: 6.94vw 0 0;
}
.mixtmt_pc #commonPage_programList {
  .programList_main {
    .themeOperation_area {
      .themeType_changeArea {
        .themeType_item {
          cursor: pointer;
          &:hover {
            background-color: var(--mixtmt_btn_tabMeun_actColor);
            color: var(--mixtmt_whiteColor);
            &:first-child {
              border-radius: 1.25vw 0 0 1.25vw;
            }
            &:last-child {
              border-radius: 0 1.25vw 1.25vw 0;
            }
          }
        }
      }
      .themeBtn_area {
        span {
          cursor: pointer;
          &:hover {
            background-color: var(--mixtmt_btn_tabMeun_actColor);
            color: var(--mixtmt_whiteColor);
          }
        }
      }
    }
  }

  .dialog_btn {
    span {
      cursor: pointer;
      &:hover {
        background-color: var(--mixtmt_greyColor0);
        color: var(--mixtmt_greyColor2);
        border-color: var(--mixtmt_greyColor0);
        &.ok {
          background-color: var(--mixtmt_mainColor);
          border-color: var(--mixtmt_mainColor);
          color: var(--mixtmt_whiteColor);
        }
      }
    }
  }
  .rowRightItem_icon {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
#commonPage_programList {
  .abs_topArea {
    .dateArea .datePicker {
      .el-date-editor.el-input {
        width: 100%;
      }
      .el-date-editor .el-input__inner {
        width: 100%;
        height: 3.47vw;
        font-size: 1.388vw;
        text-align: center;
        font-weight: bold;
        /* border: 1px solid var(--mixtmt_whiteColor);
        color: var(--mixtmt_whiteColor);
        background: transparent; */
        &::-webkit-input-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-ms-input-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-selection {
          color: var(--mixtmt_greyColor11);
          background: rgba(0, 0, 0, 0.25);
          font-weight: lighter;
        }
        &::selection {
          color: var(--mixtmt_greyColor11);
          background: rgba(0, 0, 0, 0.25);
          font-weight: lighter;
        }
      }
      .el-input--prefix .el-input__inner {
        padding-left: 3vw;
      }
      .el-input--suffix .el-input__inner {
        padding-right: 3vw;
      }
      .el-range-editor.el-input__inner {
        padding: 0.208vw 0.694vw;
      }
      .el-date-editor .el-range__icon,
      .el-date-editor .el-range__close-icon {
        width: 2.083vw;
        height: auto;
        line-height: 1;
        font-size: 1.66vw;
        margin-left: 0;
        color: var(--mixtmt_whiteColor);
        line-height: 3.054vw;
      }
      .el-date-editor .el-range-input {
        width: calc(46% - 2.083vw);
        font-size: 1.388vw;
        color: var(--mixtmt_whiteColor);
        font-weight: bold;
        background: transparent;
        &::-webkit-input-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &:-ms-input-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &:-moz-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-selection {
          color: var(--mixtmt_greyColor11);
          background: rgba(0, 0, 0, 0.25);
          font-weight: lighter;
        }
        &::selection {
          color: var(--mixtmt_greyColor11);
          background: rgba(0, 0, 0, 0.25);
          font-weight: lighter;
        }
      }
      .el-date-editor .el-range-separator {
        padding: 0;
        height: auto;
        line-height: 1;
        font-size: 1.388vw;
        width: 8%;
        color: var(--mixtmt_whiteColor);
      }

      .el-input__icon {
        color: var(--mixtmt_whiteColor);
        line-height: 3.054vw;
        font-size: 1.66vw;
      }
    }
  }
  .el-dialog__wrapper {
    width: 100%;
    z-index: 1610 !important;
    .mixtmt_dialog {
      border-radius: 1.042vw;
      transform: translateY(-50%);
      top: 50%;
      .el-dialog__header {
        padding: 2.083vw 2.778vw 1.043vw 2.778vw;
        .el-dialog__title {
          line-height: 1.8vw;
          font-size: 1.25vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
      }
      .el-dialog__body {
        padding: 1.043vw 2.778vw;
        .dialogText {
          line-height: 1.388vw;
          font-size: 0.972vw;
          color: var(--mixtmt_greyColor2);
        }
        .row_input {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          .row_title {
            padding-right: 0.694vw;
            width: 6.94vw;
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor3);
            text-align: center;
          }
          .el-input {
            color: var(--mixtmt_greyColor2);
            input {
              height: 2.778vw;
              line-height: calc(2.778vw - 2px);
              font-size: 0.972vw;
              background-color: var(--mixtmt_greyColor8);
              padding: 0 4vw 0 1.042vw;
            }
            .el-input__count .el-input__count-inner {
              background-color: var(--mixtmt_greyColor8);
            }
          }
        }
      }
      .el-dialog__footer {
        padding: 2.083vw 2.778vw;
        .dialog-footer {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          span {
            width: 10.416vw;
            height: 2.778vw;
            background-color: var(--mixtmt_whiteColor);
            line-height: calc(2.778vw - 2px);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor6);
            border-radius: 0.347vw;
            &.ok {
              background-color: var(--mixtmt_mainColor3);
              color: var(--mixtmt_whiteColor);
            }
            &:nth-child(2) {
              margin-left: 1.388vw;
            }
          }
        }
      }
    }
  }
}

.mixtmt_pc #commonPage_programList {
  .el-dialog__wrapper {
    z-index: 1610 !important;
    .mixtmt_dialog {
      .el-dialog__headerbtn:focus .el-dialog__close,
      .el-dialog__headerbtn:hover .el-dialog__close {
        color: var(--mixtmt_mainColor);
      }
      .el-dialog__footer {
        .dialog-footer {
          span {
            cursor: pointer;
            &:hover {
              background-color: var(--mixtmt_mainColor6);
              color: var(--mixtmt_whiteColor);
              border-color: var(--mixtmt_mainColor6);
            }
          }
        }
      }
    }
  }
}
</style>
